var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "transition-all duration-300 outline-none bl-button",
      class: [
        _vm.type ? "bl-button-" + _vm.type : "",
        _vm.icon ? "bl-button-icon" : "",
        _vm.label ? "bl-button-label" : "",
        _vm.loading ? "bl-button-loading cursor-wait" : "",
        _vm.disabled ? "bl-button-disabled" : "",
        _vm.reverse ? "bl-button-reverse" : "",
        _vm.type.includes("dense") || _vm.dense ? "bl-button-dense" : ""
      ],
      attrs: {
        "data-id": _vm.dataId,
        disabled: _vm.disabled || _vm.loading,
        type: _vm.buttonType,
        title: _vm.title || _vm.label
      },
      on: {
        click: function($event) {
          return _vm.$emit("clicked")
        }
      }
    },
    [
      _vm.icon
        ? _c("BlIcon", {
            staticClass: "bl-button-icon",
            class: [
              _vm.type.includes("dense") || _vm.dense ? "bl-icon-dense" : ""
            ],
            attrs: {
              dataId: _vm.dataId,
              icon: _vm.icon,
              color: _vm.getColor(_vm.type)
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.label
        ? _c(
            "label",
            {
              staticClass: "truncate bl-button-label",
              attrs: { "data-id": _vm.dataId }
            },
            [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-390e0ff2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-390e0ff2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlInputButton.vue
// module id = null
// module chunks = 